import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StyleguideModule } from '@woolworthsnz/styleguide';

@Component({
	selector: 'store-locator-search-card',
	template: `
		<cdx-svg-icon [name]="iconName" class="card-icon" size="large" fill="currentColor"></cdx-svg-icon>
		<ng-content select="[title]"></ng-content>
		<ng-content select="[action]"></ng-content>
	`,
	styleUrls: ['./search-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [StyleguideModule]
})
export class SearchCardComponent {
	@Input() iconName: string;
}
